// extracted by mini-css-extract-plugin
module.exports = {"markdownContainer":"styles-module--markdown-container--3y9GC","mobile":"styles-module--mobile--JfX3x","hide":"styles-module--hide--9fkkY"};